import Handlebars from 'handlebars'

const hb = Handlebars.create()

hb.registerHelper('xif', function(expression, options) {
  return hb.helpers['x'].apply(this, [expression, options]) ? options.fn(this) : options.inverse(this)
})

hb.registerHelper('x', function(expression, options) {
  let result

  let context = this

  try {
    // eslint-disable-next-line no-new-func
    let func = new Function(...Object.keys(context), 'return ' + expression)
    result = func(...Object.values(context))
  }
  catch (e) {
    console.warn('•Expression: {{x \'' + expression + '\'}}\n•JS-Error: ', e, '\n•Context: ', context)
  }

  return result
})

hb.registerHelper('add', function(a, b) {
  if (typeof a === 'number' && typeof b === 'number') {
    return Number(a) + Number(b)
  }
  if (typeof a === 'string' && typeof b === 'string') {
    return a + b
  }
  return ''
})

hb.registerHelper('keyValues', function(a) {
  return Object.entries(a)
    .map(([k, v]) => {
      if (typeof v === 'string') {
        return `"${k}": "${v}"`
      }
      else {
        return `"${k}": ${JSON.stringify(v)}`
      }
    })
    .join(',\n')
})

hb.registerHelper('stringify', function(a) {
  return a ? JSON.stringify(a) : 'null'
})

hb.registerHelper('orNullValue', function(a) {
  return a || 'null'
})

export const formatTemplate = (templateString, values) => {
  const template = hb.compile(templateString)
  // console.log(`template: ${templateString}`)
  // console.log(`Values: ${JSON.stringify(values, null, 2)}`)
  return template(values)
}
